// extracted by mini-css-extract-plugin
export var acceptButton = "_2h-5";
export var fullContent = "_2h-4";
export var link = "_2h-6";
export var linkIcon = "_2h-7";
export var sideContent = "_2h-3";
export var sideImage = "_2h-2";
export var sideImageWrapper = "_2h-1";
export var splitLayout = "_2h-0";